import { render, staticRenderFns } from "./ReturnRequest.vue?vue&type=template&id=48476110&"
import script from "./ReturnRequest.vue?vue&type=script&lang=js&"
export * from "./ReturnRequest.vue?vue&type=script&lang=js&"
import style0 from "./ReturnRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports